/**
 * Baner zgody RODO — steruje Google Consent Mode v2. Dopóki user nie kliknie,
 * GTM ma stan `denied` (ustawiony w index.html przed kontenerem), więc tagi
 * GA4/Meta/Ads nie zapisują cookies. Pokazuje się tylko, gdy jeszcze nie wybrał;
 * wybór trwały (localStorage).
 */
import { useState } from "react";
import { getConsent, setConsent } from "@/lib/analytics";

const PRIVACY_URL = "https://adresflow.com/polityka-prywatnosci";

export function ConsentBanner() {
  const [choice, setChoice] = useState<"granted" | "denied" | null>(() => getConsent());

  if (choice) return null;

  const decide = (value: "granted" | "denied") => {
    setConsent(value);
    setChoice(value);
  };

  return (
    <div
      style={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1000,
        maxWidth: 520,
        margin: "0 auto",
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: 12,
        boxShadow: "var(--shadow-soft, 0 8px 24px rgba(0,0,0,0.3))",
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      <div style={{ fontSize: 13, lineHeight: 1.55, color: "var(--text)" }}>
        Używamy plików cookies do analityki i marketingu, aby ulepszać AdresFlow. Możesz się zgodzić lub odmówić — odmowa nie wpływa na działanie aplikacji.{" "}
        {/* Absolutny URL: polityka żyje na stronie marketingowej (v1), v2 to sama aplikacja. */}
        <a
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "var(--accent)", textDecoration: "underline" }}
        >
          Polityka prywatności
        </a>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button className="btn btn--subtle btn--sm" onClick={() => decide("denied")}>Odmawiam</button>
        <button className="btn btn--primary btn--sm" onClick={() => decide("granted")}>Akceptuję</button>
      </div>
    </div>
  );
}
